export default {
    name: "TariffRatesEditTab",

    props: {
        rate_rows: {
            type: Array,
            default: () => []
        },
        context: {
            type: Object,
            default: null
        },
        tariff_book: {
            type: Object,
            default: null
        },
        is_saving: {
            type: Boolean,
            default: false
        },
        supports_rate_updates: {
            type: Boolean,
            default: false
        },
        format_date: {
            type: Function,
            required: true
        },
        get_metric_rows: {
            type: Function,
            required: true
        }
    },

    emits: ["close", "save", "update-effective", "update-metric"],

    computed: {
        latest_rate() {
            return this.rate_rows[0] || null;
        },

        historical_rates() {
            return this.rate_rows.slice(1);
        }
    },

    methods: {
        get_detail_fields(rate) {
            return [
                {
                    label: "Tariff book name",
                    value: this.tariff_book?.name || this.context?.property_name || "-"
                },
                {
                    label: "Tariff name",
                    value: this.context?.tariff_name || rate?.name || "-"
                },
                {
                    label: "Tariff category",
                    value: rate?.tariff_category || this.context?.tariff_category || this.tariff_book?.tariff_category || "-"
                }
            ];
        },

        get_rate_version_label(rate) {
            return `${this.format_date(rate?.effective_from)} - ${this.format_date(rate?.effective_to)}`;
        }
    }
};
